export default __webpack_public_path__ + "static/media/Song of the Four Wailing Elohim.8b36eaf9.jpg";